import { alpha, styled } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';

export const StyledStackSocials = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  color: theme.palette.text.disabled,
}));

export const StyledGradientButton = styled(ButtonBase)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  borderRadius: theme.shape.borderRadius * 2,
  color: theme.palette.text.primary,
  background: theme.palette.createBrandGradients.primary(
    theme.palette.mode === 'light'
      ? {
          alpha1: alpha(theme.palette.common.white, 0.7),
          alpha2: alpha(theme.palette.common.white, 0.2),
        }
      : {
          alpha1: alpha(theme.palette.common.black, 0.2),
          alpha2: alpha(theme.palette.common.white, 0.1),
        },
  ),
  zIndex: 1,
  position: 'relative',
  ...theme.typography.textSm,
  '::before':
    theme.palette.mode === 'dark'
      ? {
          content: '""',
          position: 'absolute',
          top: -0.35,
          left: -0.35,
          zIndex: -1,
          bottom: -0.35,
          right: -0.35,
          margin: 2,
          borderRadius: theme.shape.borderRadius * 2,
          background: theme.palette.createBrandGradients.primary({
            direction: 'left',
            alpha1: alpha(theme.palette.common.black, 0.8),
            alpha2: alpha(theme.palette.common.white, 0.01),
          }),
        }
      : undefined,
})) as typeof ButtonBase;
